// Shared helpers for deep-linking to audit log entries in vitalstatistix.

export const AUDIT_LOG_TAB_ID = 'auditLogEntries';

// Absolute, shareable URL for a specific audit log entry on an account page.
// Example: https://<host>/accounts/<accountId>?tab=auditLogEntries&entry=<entryId>
export function buildAuditLogEntryDeepLink(accountId: string, entryId: string): string {
  const url = new URL(`/accounts/${accountId}`, window.location.origin);
  url.searchParams.set('tab', AUDIT_LOG_TAB_ID);
  url.searchParams.set('entry', entryId);
  return url.toString();
}
